import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    accordion: {
      "& .MuiAccordion-root": {
        borderRadius: "12px",
        boxShadow:
          "0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.10)",
      },
    },
    cardContainer: {
      padding: "20px",
      width: "100%",
      borderRadius: "12px",
    },
  };
});
